/* Keep Warehouse's existing panel-height calculation aware of this section. */
(() => {
  if (customElements.get('dsn-top-bar')) return;
  customElements.define('dsn-top-bar', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.offsetHeight}px`);
      });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer.disconnect();
      document.documentElement.style.removeProperty('--announcement-bar-height');
    }
  });
})();
